module.exports = __webpack_public_path__ + "37b17844a071d9b42b862ffe98bcdd18.svg";